module.exports = __webpack_public_path__ + "static/media/snowflake.e88176b6.svg";